// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3ptRx","footer":"ModalFilter_footer__amGsE"};